<template>
  <div>
    <bread-crumb :categorialeilao="leilao.categorialeilao" :nomeLeilao="leilao.nm"></bread-crumb>
    <loading v-if="loadingPage || loadingRefresh"></loading>
    <div v-if="naoEncontradoMeusLotes"><!-- MENSAGEM DE NÃO ENCONTRADO -->
      <nao-encontrado :leilaoId="leilao.id" :cookie="cookie"></nao-encontrado>
    </div>
    <div v-show="!loadingPage && !naoEncontradoMeusLotes"><!-- LISTAGEM - SALA DE DISPUTA -->
      <header-disputa :dadosLeilao="dadosLeilao" :leilaoid="leilaoId" :lotes="lotes"></header-disputa>
      <mensagem-box :message="message" :liberado="liberado" :usuario="usuario"></mensagem-box>
      <botoes-rotas :dadosRequisicao="dadosRequisicao"></botoes-rotas>

      <loading v-if="loadingPage || loadingRefresh"></loading>

      <div v-show="!firstLoadMeusLotes && !loadingRefresh" class="tw-hidden xl:tw-flex tw-justify-end tw-items-center tw-mb-6">
        <div class="tw-flex tw-bg-white tw-p-5 tw-rounded-md tw-gap-3 tw-text-gray-500">
          <a href @click="refreshPage" title="Atualizar todos os lotes"><i class="icon-refresh hover:tw-text-jrBlue-100"></i></a>
        </div>
      </div>

      <transition name="fade">
        <ul id="grid" class="container tw-flex tw-justify-center tw-items-center tw-flex-wrap 2xl:tw-gap-28 tw-gap-12">
          <li v-for="(lote, idx) in lotes" :key="idx" class="tw-w-3/4 xl:tw-w-[240px] tw-flex tw-flex-col tw-text-jrBlue-100 tw-bg-white tw-rounded-xl tw-pb-4 hover:tw-scale-105">
            <card
              :leilao="leilao"
              :dados="lote"
              :liberado="liberado"
              :automatico="leilao.bn_fechamentoautomatico"
              :usuarioid="usuario.id"
            />
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>
<script>
// PLUGIN COMPONENTS
import Paginate from 'vuejs-paginate'
import {Stretch} from 'vue-loading-spinner'
import { Carousel, Slide } from 'vue-carousel';

// LAYOUT COMPONENTS
import Card from '@/components/shared/Card'
import BreadCrumb from '@/components/shared/BreadCrumb'
import BotoesRotas from '@/components/shared/BotoesRotas'
import NaoEncontrado from '@/components/shared/NaoEncontrado'
import HeaderDisputa from '@/components/shared/HeaderDisputa'
import MensagemBox from '@/components/shared/MensagemBox'
import MensagemBoxLeilao from '@/components/shared/MensagemBoxLeilao'
import Loading from "./shared/Loading.vue";

export default {
  name: 'SalaDisputa',
  props: ["dadosLeilao"],
  components:{
    Loading,
    BreadCrumb,
    Card,
    Stretch,
    Paginate,
    Carousel,
    Slide,
    BotoesRotas,
    NaoEncontrado,
    HeaderDisputa,
    MensagemBox,
    MensagemBoxLeilao
  },
  data () {
    return {
      leilaoId: this.$route.params.id,
      leilao: [],
      lotes: [],
      visitas: [],
      lotesAcompanhar: [],
      config_leiloeiro: [],
      dados_condicao: [],
      dadosRequisicao: {},
      usuario: [],
      filtros: [],
      errors: [],
      value_video: null,
      loadingPage: true,
      loadingRefresh: false,
      naoEncontradoMeusLotes: false,
      firstLoadMeusLotes: true,
      liberado: false,
      parametrosFiltro: '',
      refreshMeusLotes:null,
      refreshCountMeusLotes: 30000,
      cookie: true,
      message: '',
      salaDisputa: null,
      lotesStatusReference: [],
      lotesLanceReference: [],
      lotesIncrementoReference: [],
      lotesDtfechamentoReference: []
    }
  },
  methods: {
    loadMsg () {
      // VERIFICA STATUS MENSAGEM
      if(this.leilao.statusleilao_id == 1){ //Core_Resource_Statusleilao::FISICO
        this.message = 'Leilão presencial sem participação online.'
        this.liberado = false
      }else if (this.leilao.statusmontagem_id !== 3){ //Core_Resource_Statusmontagem::LISTA_COMPLETO
        if(this.leilao.statusmontagem_id == 5){ //Core_Resource_Statusmontagem::SUSPENSO
          this.message = 'Leilão suspenso'
          this.liberado = false
        }else{
          this.message = 'Leilão ainda não liberado para lances.'
          this.liberado = false
        }
      }else if (this.usuario.id !== null){
        if(this.usuario.statusliberacaoonline_id !== 3){
          this.message = this.usuario.nm_statusliberacaomensagem
          this.liberado = false
        }else if(this.dados_condicao.aceitou_condicao == false){
          this.message = `
                        <a style="margin-left: 10px;" title="Condições de Venda" href="javascript:void(0)">
                            Clique aqui para aceitar as condições de venda.
                        </a>
                    `
          this.liberado = false
        }else{
          this.message = this.usuario.nm_statusliberacaomensagem
          this.liberado = true
        }
      }else {
        this.message = 'Usuário não logado, para iniciar os lances é preciso estar logado.'
        this.liberado = false
      }
    },

    /* atualiza lotes */
    refreshLotes() {
      var db = this.firebase_db;
      var self = this;

      if(this.lotesAcompanhar.length > 0) {
        var Promise = this.$root.bluebird;

        Promise.map(this.lotesAcompanhar, function(lote) {
          return db.ref(`/lote/${self.leilaoId}`)
            .child(lote).once('value', s => s);

        }).then(function (lotes) {
          self.lotes = lotes.map(function(lote) { return lote.val()})
          self.saladisputa.ordenaLotesPorSeq(self.lotes)
          self.saladisputa.observaLotesStatusLance(self.lotes)
          self.saladisputa.configuraFavoritos()
          self.saladisputa.configuraVisitas()

          self.loadingPage = false
          self.loadingRefresh = false
          self.firstLoadMeusLotes = false
        });
      } else {
        self.loadingPage = false
        self.loadingRefresh = false
        self.firstLoadMeusLotes = false
        self.naoEncontradoMeusLotes = true
      }
    },

    refreshDadosGerais() {
      const hostName = location.protocol + "//" + window.HOSTNAME;

      fetch(`${hostName}/leilao/get-dados-gerais?leilao_id=${this.leilaoId}`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Erro ao obter dados gerais: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          this.usuario = data.usuario;
          this.visitas = data.visitas;
          // Houve mudança nos favoritos, refresh lotes novamente
          this.lotesAcompanhar = this.usuario.interesse;
          this.refreshLotes();
        })
        .catch(error => {
          console.error("Erro ao atualizar dados gerais:", error.message);
        });
    },
    refreshPage (ev){ // REFRESH
      this.loadingRefresh = true
      this.refreshLotes()
    },
    refreshFirebase() {

    }
  },
  watch: {
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
    }
  },
  created(){
    this.leilao = this.dadosLeilao
    this.saladisputa = new window.saladisputa(this)

    clearInterval(window.INTERVALO_BUSCA)
    clearInterval(window.INTERVALO_CATEGORIA)

    // refresh leilao firebase
    this.loadingPage = true

    this.$on('dados-gerais', function(data) {
      this.config_leiloeiro = data.config_leiloeiro
      this.dados_condicao = data.dados_condicao
      this.usuario = data.usuario
      this.lotesAcompanhar = this.usuario.interesse
      this.dadosRequisicao.isLogado = this.usuario.id !== null ? true : false
      this.visitas = data.visitas

      this.loadMsg()
      this.refreshLotes()

      // isLogado ?
      if(this.usuario.id !== null){
        sessionStorage.setItem('isLogado', this.usuario.id !== null ? true : false)
      }
    })

    this.$on('favoritoModificado', function (_self) {
      this.refreshDadosGerais()
    })

    this.cookie = this.$root.cookieAtivo
    this.$root.MensagemBrowserCookie()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MeusLotes.vue